<template>
  <div class="finish">
    <div>
      <i class="iconfont icon-shiliangzhinengduixiang"></i>
      {{pc_lang.Congratulations}}{{mainTitle}}
    </div>
    <p>
      {{descWord}}
    </p>
    <p v-show="countBool">
      {{pc_lang.The_system_is_processing}} <span v-text="countDownSeconds"></span>秒
    </p>
    <p v-show="btnBool">
      <router-link tag="el-button" size="medium" :to="routeA" v-show="routeWordA != ''">{{routeWordA}}</router-link>
      <!-- <el-button size="medium">财富中心</el-button> -->
      <el-button type="primary" size="medium" v-show="routeWordB != ''" @click="still">{{routeWordB}}</el-button>
    </p>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  name: 'finish',
  props:{
    // 倒计时时间
    count: {
      type: Number,
      default: ()=> 8
    },
    // 是否开启倒计时
    countBool: {
      type: Boolean,
      default: ()=> false
    },
    // 是否开启btn
    btnBool: {
      type: Boolean,
      default: ()=> false
    },
    routeA: {
      type: String,
      default: ()=> '/index'
    },
    routeWordA: {
      type: String,
      default: ()=> ''
    },
    routeB: {
      type: String,
      default: ()=> ''
    },
    routeWordB: {
      type: String,
      default: ()=> ''
    },
    mainTitle: {
      type: String,
      default: ()=> ''
    },
    descWord: {
      type: String,
      default: ()=> ''
    },
  },
  data() {
    return {
      // 倒计时时间
      countDownSeconds: this.count,
    }
  },
  computed: {

  },
  async mounted() {

  },
  created() {
    // this.countDown()
    if (this.countBool) {
      this.countDown()
    }
  },
  methods: {
    /* 倒计时 */
    countDown() {
      let page = this.$route.name
      let timer = setInterval(()=>{
        this.countDownSeconds --
        if (this.countDownSeconds <= 0) {
          clearInterval(timer)
          this.$router.push({path: this.routeA})
        }else if( this.$route.name != page ) {
          clearInterval(timer)
        }
      }, 1000)
    },

    still() {
      let url = this.routeB || '/index'
      console.log(url)
      if (this.routeB == 'fresh') {
        window.location.href = location.href
      }else{
        this.$router.push({path: url})
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.finish{
  text-align: center;
  width: 436px;
  margin: 40px auto;
  i{
    font-size: 24px;
  }
  >div{
    font-size: 28px;
    margin-bottom: 10px;
    color: $blue;
  }
  p{
    margin: 20px;
    color: #555;
    span{
      color: $blue;
    }
  }
}
</style>